export default __webpack_public_path__ + "static/media/ER19.4678e723.png";